<div class="row portfolio-series-title-row title-row grid grid-cols-1 mr-0">
  <div class="title">
    <div class="flex">
      <h2 class="title__summary text-xl md:text-4xl">Investor Summary by Portfolio</h2>
      <app-info-icon tooltipPosition="right" tooltipInfo="Net of GCM Fees and Expenses"
        tooltipClass="info-icon-top-2 md:top-0.5 lg:info-icon-top-0">
      </app-info-icon>
    </div>
  </div>
  <div class="since-inception-text block">Since Inception</div>
</div>
@for (portfolio of investorPortfolios() | sortBy:'asc' : 'ticker'; track portfolio.masterId; let i = $index) {
  <app-portfolio-summary [portfolioSummary]="portfolio" [iconSet]="iconSet()" [selectedAsOfDate]="selectedAsOfDate()" [investorId]="activeInvestorMetadata().id" [showFirstSeries]="i===0"></app-portfolio-summary>
}